import { lazy } from "react"

export const MoneyFlowProvider = lazy(() => import("./context/MoneyFlowProvider.tsx")
    .then((module) => ({ default: module.MoneyFlowProvider })))
export const MoneyFlowGrid = lazy(() => import("./components/MoneyFlowGrid.tsx")
    .then((module) => ({ default: module.MoneyFlowGrid })))
export const ReportView = lazy(() => import('./components/Report/Report.tsx')
    .then((module) => ({ default: module.ReportView })))
export const Homepage = lazy(() => import("./components/Homepage/Homepage.tsx")
    .then((module) => ({ default: module.Homepage })))
export const DocumentView = lazy(() => import('./components/DocumentView.tsx')
    .then((module) => ({ default: module.DocumentView })))
export const TasksView = lazy(() => import('./components/TaskPage/TasksView.tsx')
    .then((module) => ({ default: module.TasksView })))
